export default function UnityLogo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.58948 11.8889H3.64951L0 8L3.64951 4.11111H5.58948L6.56318 2.35333L11.6101 1L13 6.24222L12.0263 8L13 9.75778L11.6101 15L6.56318 13.6467L5.58948 11.8889ZM5.69354 11.6944L9.50658 12.7678L7.30646 8.77778H2.90623L5.69354 11.6944ZM10.7999 11.99L11.8256 8L10.7999 4.01L8.59234 8L10.7999 11.99ZM5.69354 4.30556L2.90623 7.22222H7.30646L9.50658 3.23222L5.69354 4.30556Z"
        fill="var(--text-primary-color)"
        className="path-fill"
      />
    </svg>
  );
}
